// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.modal-action__close {
  padding: 20px;
  cursor: pointer;
}

.salary-stats-chart {
  z-index: 1;
  position: relative;
  padding: 2% 5%;
  background: #ffffff;
  border-radius: 16px;
}
.salary-stats-chart__modal-header {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  color: #333333;
  padding-bottom: 10px;
  text-align: center;
}
.salary-stats-chart__modal-subheader {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #868686;
  text-align: center;
}
.salary-stats-chart__modal-subheader__date {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #e47c77;
}
.salary-stats-chart__modal-body {
  padding: 30px;
  margin-top: 5px;
  height: 80%;
}
.salary-stats-chart__chart {
  width: 100%;
  padding-top: 20px;
  background: #fafafa;
  border-radius: 12px;
  background: #fafafa;
}

.modal-body {
  padding: 20px;
  margin-top: 4px;
}

.chart {
  border-radius: 16px;
}
.chart__head-text {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  align-items: center;
  color: #1c1c1c;
  border-bottom: 1px solid black;
}
.chart__head-date {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.4);
  border-bottom: 1px solid black;
  margin-left: 30px;
}

.chart-absenteeismTardinessStats {
  width: 100%;
}

.abTable {
  width: 100%;
  border-collapse: collapse;
}
.abTable__td-progress {
  height: 100%;
  background-color: #f7f9fb;
  border-radius: 16px;
  border: 5px solid white;
}
.abTable__td {
  width: 10%;
}

.pie-chart {
  background: #f7f9fb;
  border-radius: 16px;
  padding: 2% 5%;
}
.pie-chart__dropdown {
  float: right;
}
.pie-chart__head {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #1c1c1c;
}

.chart-data {
  width: 150px;
  font-family: "Noto Sans KR";
  font-style: normal;
  line-height: 40px;
}
.chart-data__span {
  margin-left: 40px;
}

.age-dist {
  background: #f7f9fb;
  border-radius: 16px;
  padding: 6%;
  height: 100%;
}
.age-dist__head {
  display: flex;
  justify-content: space-between;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
}
.age-dist__text {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  color: #000000;
}
.age-dist__span {
  font-size: 14px;
}

.fonts {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
}

.line-chart {
  margin-top: 20px;
}

.line-text {
  display: flex;
  justify-content: space-between;
}

.absenteeism-stats-chart {
  z-index: 1;
  position: relative;
  padding: 2% 5%;
  background: #ffffff;
  border-radius: 16px;
}
.absenteeism-stats-chart__modal-header {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 36px;
  color: #333333;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: center;
}
.absenteeism-stats-chart__modal-dropdown {
  display: flex;
  margin: auto;
  width: 85px;
  height: 34px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px 8px 8px 8px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
}
.absenteeism-stats-chart__modal-body {
  display: flex;
  flex-direction: column;
}
.absenteeism-stats-chart__modal-body__middle {
  display: flex;
  flex-direction: column;
}
.absenteeism-stats-chart__chart {
  padding: 10%;
  height: 200px;
  width: 200px;
  display: flex;
  margin: auto;
}
.absenteeism-stats-chart__chart__chart1 {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #da7772;
}
.absenteeism-stats-chart__chart__perc1 {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
}
.absenteeism-stats-chart__chart__chart2 {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #fed159;
}
.absenteeism-stats-chart__chart__perc2 {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
}
.absenteeism-stats-chart__chart__chart3 {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #fd966c;
}
.absenteeism-stats-chart__chart__perc3 {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
}
.absenteeism-stats-chart__modal-footer {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  align-items: center;
  align-items: center;
  text-align: center;
}
.absenteeism-stats-chart__date {
  margin: 0 5%;
  font-size: 1.2rem;
  color: #999999;
}
.absenteeism-stats-chart__color1 {
  color: #e47c77;
}
.absenteeism-stats-chart__color2 {
  color: #fed159;
}
.absenteeism-stats-chart__color3 {
  color: #fd966c;
}

.employee-stats-chart {
  z-index: 1;
  position: relative;
  padding: 3% 0;
  width: 540px;
  height: 420px;
  background: #ffffff;
  border-radius: 16px;
}
.employee-stats-chart__modal-header {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  color: #333333;
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: center;
}
.employee-stats-chart__modal-subheader {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #868686;
  text-align: center;
}
.employee-stats-chart__modal-subheader__span {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  text-align: center;
  color: #075453;
}
.employee-stats-chart__modal-subheader__span2 {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #075453;
}
.employee-stats-chart__modal-body {
  display: flex;
  margin-top: 40px;
}
.employee-stats-chart__modal-body__left {
  width: 20%;
  margin: auto;
  display: block;
  text-align: center;
  cursor: pointer;
}
.employee-stats-chart__modal-body__left-up {
  width: 20%;
  margin: auto;
  display: block;
  text-align: center;
  cursor: pointer;
  padding-bottom: 58px;
}
.employee-stats-chart__modal-body__middle {
  width: 60%;
}
.employee-stats-chart__modal-body__right {
  width: 20%;
  margin: auto;
  display: block;
  text-align: center;
  cursor: pointer;
}
.employee-stats-chart__modal-body__right-up {
  width: 20%;
  margin: auto;
  display: block;
  text-align: center;
  cursor: pointer;
  padding-bottom: 58px;
}
.employee-stats-chart__popup {
  background: #333333;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  align-items: center;
  text-align: center;
  color: #ffffff;
  border-radius: 8px !important;
}
.employee-stats-chart__popup__span {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  align-items: center;
  text-align: center;
  color: #ffffff;
}
.employee-stats-chart__pie-chart {
  height: 150px;
  width: 150px;
  margin: auto;
}
.employee-stats-chart__progress-bar__line {
  display: flex;
  margin-top: 25px;
  align-items: center;
}
.employee-stats-chart__progress-bar__text {
  width: 60px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
}
.employee-stats-chart__progress-bar__bar {
  padding-top: 5px;
}
.employee-stats-chart__modal-footer {
  margin-top: 30px;
}
.employee-stats-chart__modal-footer__table {
  margin: auto;
}
.employee-stats-chart__modal-footer__items {
  display: flex;
  padding-left: 15px;
}
.employee-stats-chart__modal-footer__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  color: #868686;
  padding-right: 10px;
}
.employee-stats-chart__modal-footer__span {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/stat-modals/stat-modals.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AACJ;;AAGI;EACI,aAAA;EACA,eAAA;AAAR;;AAIA;EACI,UAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AADJ;AAGI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;AADR;AAII;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAFR;AAIQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFZ;AAMI;EACI,aAAA;EACA,eAAA;EACA,WAAA;AAJR;AAOI;EACI,WAAA;EAEA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AANR;;AAUA;EACI,aAAA;EACA,eAAA;AAPJ;;AAUA;EAEI,mBAAA;AARJ;AAUI;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EAEA,cAAA;EACA,8BAAA;AATR;AAYI;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,yBAAA;EACA,8BAAA;EACA,iBAAA;AAXR;;AAeA;EACI,WAAA;AAZJ;;AAeA;EACI,WAAA;EACA,yBAAA;AAZJ;AAcI;EACI,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;AAZR;AAeI;EACI,UAAA;AAbR;;AAiBA;EACI,mBAAA;EACA,mBAAA;EACA,cAAA;AAdJ;AAgBI;EACI,YAAA;AAdR;AAiBI;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EAEA,cAAA;AAhBR;;AAuDA;EACI,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;AApDJ;AAsDI;EACI,iBAAA;AApDR;;AAwDA;EACI,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AArDJ;AAuDI;EACI,aAAA;EACA,8BAAA;EAEA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAtDR;AAyDI;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EAEA,cAAA;AAxDR;AA0DI;EACI,eAAA;AAxDR;;AA4DA;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;AAzDJ;;AA4DA;EACI,gBAAA;AAzDJ;;AA4DA;EACI,aAAA;EACA,8BAAA;AAzDJ;;AA4DA;EACI,UAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AAzDJ;AA2DI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,iBAAA;EACA,oBAAA;EACA,kBAAA;AA1DR;AA6DI;EACI,aAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA5DR;AA+DI;EACI,aAAA;EACA,sBAAA;AA7DR;AAkEQ;EACI,aAAA;EACA,sBAAA;AAhEZ;AAuEI;EACI,YAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;AArER;AAuEQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AArEZ;AAwEQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAtEZ;AAyEQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAvEZ;AA0EQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAxEZ;AA2EQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAzEZ;AA4EQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA1EZ;AA8EI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EAEA,mBAAA;EACA,kBAAA;AA7ER;AAgFI;EACI,YAAA;EACA,iBAAA;EACA,cAAA;AA9ER;AAiFI;EACI,cAAA;AA/ER;AAkFI;EACI,cAAA;AAhFR;AAmFI;EACI,cAAA;AAjFR;;AAqFA;EACI,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAlFJ;AAoFI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAnFR;AAsFI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AApFR;AAsFQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AApFZ;AAuFQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AArFZ;AAyFI;EACI,aAAA;EACA,gBAAA;AAvFR;AAyFQ;EACI,UAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAvFZ;AA0FQ;EACI,UAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AAxFZ;AA2FQ;EACI,UAAA;AAzFZ;AA4FQ;EACI,UAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AA1FZ;AA6FQ;EACI,UAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AA3FZ;AA+FI;EACI,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;AA7FR;AA+FQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AA7FZ;AAiGI;EACI,aAAA;EACA,YAAA;EACA,YAAA;AA/FR;AAmGQ;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;AAjGZ;AAoGQ;EACI,WAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAlGZ;AAqGQ;EACI,gBAAA;AAnGZ;AAuGI;EACI,gBAAA;AArGR;AA0GQ;EACI,YAAA;AAxGZ;AA+GQ;EACI,aAAA;EACA,kBAAA;AA7GZ;AAgHQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AA9GZ;AAiHQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AA/GZ","sourcesContent":[".modal {\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2;\n}\n\n.modal-action {\n    &__close {\n        padding: 20px;\n        cursor: pointer;\n    }\n}\n\n.salary-stats-chart {\n    z-index: 1;\n    position: relative;\n    padding: 2% 5%;\n    background: #ffffff;\n    border-radius: 16px;\n\n    &__modal-header {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 34px;\n        color: #333333;\n        padding-bottom: 10px;\n        text-align: center;\n    }\n\n    &__modal-subheader {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 18px;\n        line-height: 24px;\n        text-align: center;\n        color: #868686;\n        text-align: center;\n\n        &__date {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 16px;\n            line-height: 22px;\n            color: #e47c77;\n        }\n    }\n\n    &__modal-body {\n        padding: 30px;\n        margin-top: 5px;\n        height: 80%;\n    }\n\n    &__chart {\n        width: 100%;\n        // height: 50px;\n        padding-top: 20px;\n        background: #fafafa;\n        border-radius: 12px;\n        background: #fafafa;\n    }\n}\n\n.modal-body {\n    padding: 20px;\n    margin-top: 4px;\n}\n\n.chart {\n    // background: #f7f9fb;\n    border-radius: 16px;\n\n    &__head-text {\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 600;\n        font-size: 14px;\n        align-items: center;\n\n        color: #1c1c1c;\n        border-bottom: 1px solid black;\n    }\n\n    &__head-date {\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n\n        color: rgba(0, 0, 0, 0.4);\n        border-bottom: 1px solid black;\n        margin-left: 30px;\n    }\n}\n\n.chart-absenteeismTardinessStats {\n    width: 100%;\n}\n\n.abTable {\n    width: 100%;\n    border-collapse: collapse;\n\n    &__td-progress {\n        height: 100%;\n        background-color: #f7f9fb;\n        border-radius: 16px;\n        border: 5px solid white;\n    }\n\n    &__td {\n        width: 10%;\n    }\n}\n\n.pie-chart {\n    background: #f7f9fb;\n    border-radius: 16px;\n    padding: 2% 5%;\n\n    &__dropdown {\n        float: right;\n    }\n\n    &__head {\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 600;\n        font-size: 14px;\n\n        color: #1c1c1c;\n    }\n}\n\n// @media (min-width: 800px) and (max-width: 1000px) {\n//     .pie-chart-media {\n//         height: 200px;\n//         width: 200px;\n//     }\n// }\n\n// @media (min-width: 1000px) and (max-width: 1200px) {\n//     .pie-chart-media {\n//         height: 200px;\n//         width: 200px;\n//     }\n// }\n\n// @media (min-width: 1200px) and (max-width: 1400px) {\n//     .pie-chart-media {\n//         height: 200px;\n//         width: 250px;\n//     }\n// }\n\n// @media (min-width: 1400px) and (max-width: 1600px) {\n//     .pie-chart-media {\n//         height: 200px;\n//         width: 250px;\n//     }\n// }\n\n// @media (min-width: 1600px) {\n//     .pie-chart-media {\n//         height: 200px;\n//         width: 300px;\n//     }\n// }\n\n.chart-data {\n    width: 150px;\n    font-family: 'Noto Sans KR';\n    font-style: normal;\n    line-height: 40px;\n\n    &__span {\n        margin-left: 40px;\n    }\n}\n\n.age-dist {\n    background: #f7f9fb;\n    border-radius: 16px;\n    padding: 6%;\n    height: 100%;\n\n    &__head {\n        display: flex;\n        justify-content: space-between;\n\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 600;\n        font-size: 14px;\n    }\n\n    &__text {\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 24px;\n\n        color: #000000;\n    }\n    &__span {\n        font-size: 14px;\n    }\n}\n\n.fonts {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n}\n\n.line-chart {\n    margin-top: 20px;\n}\n\n.line-text {\n    display: flex;\n    justify-content: space-between;\n}\n\n.absenteeism-stats-chart {\n    z-index: 1;\n    position: relative;\n    padding: 2% 5%;\n    background: #ffffff;\n    border-radius: 16px;\n\n    &__modal-header {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 26px;\n        line-height: 36px;\n        color: #333333;\n\n        padding-top: 10px;\n        padding-bottom: 10px;\n        text-align: center;\n    }\n\n    &__modal-dropdown {\n        display: flex;\n        margin: auto;\n        width: 85px;\n        height: 34px;\n        background: #ffffff;\n        border: 1px solid #e9e9e9;\n        border-radius: 8px 8px 8px 8px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        color: #333333;\n    }\n\n    &__modal-body {\n        display: flex;\n        flex-direction: column;\n\n        &__left {\n        }\n\n        &__middle {\n            display: flex;\n            flex-direction: column;\n        }\n\n        &__right {\n        }\n    }\n\n    &__chart {\n        padding: 10%;\n        height: 200px;\n        width: 200px;\n        display: flex;\n        margin: auto;\n\n        &__chart1 {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n            line-height: 38px;\n            color: #da7772;\n        }\n\n        &__perc1 {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 18px;\n        }\n\n        &__chart2 {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n            line-height: 38px;\n            color: #fed159;\n        }\n\n        &__perc2 {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 18px;\n        }\n\n        &__chart3 {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n            line-height: 38px;\n            color: #fd966c;\n        }\n\n        &__perc3 {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 18px;\n        }\n    }\n\n    &__modal-footer {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 20px;\n        line-height: 30px;\n        align-items: center;\n\n        align-items: center;\n        text-align: center;\n    }\n\n    &__date {\n        margin: 0 5%;\n        font-size: 1.2rem;\n        color: #999999;\n    }\n\n    &__color1 {\n        color: #e47c77;\n    }\n\n    &__color2 {\n        color: #fed159;\n    }\n\n    &__color3 {\n        color: #fd966c;\n    }\n}\n\n.employee-stats-chart {\n    z-index: 1;\n    position: relative;\n    padding: 3% 0;\n    width: 540px;\n    height: 420px;\n    background: #ffffff;\n    border-radius: 16px;\n\n    &__modal-header {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 34px;\n        color: #333333;\n\n        padding-top: 5px;\n        padding-bottom: 5px;\n        text-align: center;\n    }\n\n    &__modal-subheader {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 18px;\n        line-height: 24px;\n        color: #868686;\n        text-align: center;\n\n        &__span {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n            line-height: 38px;\n            text-align: center;\n            color: #075453;\n        }\n\n        &__span2 {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 20px;\n            color: #075453;\n        }\n    }\n\n    &__modal-body {\n        display: flex;\n        margin-top: 40px;\n\n        &__left {\n            width: 20%;\n            margin: auto;\n            display: block;\n            text-align: center;\n            cursor: pointer;\n        }\n\n        &__left-up {\n            width: 20%;\n            margin: auto;\n            display: block;\n            text-align: center;\n            cursor: pointer;\n            padding-bottom: 58px;\n        }\n\n        &__middle {\n            width: 60%;\n        }\n\n        &__right {\n            width: 20%;\n            margin: auto;\n            display: block;\n            text-align: center;\n            cursor: pointer;\n        }\n\n        &__right-up {\n            width: 20%;\n            margin: auto;\n            display: block;\n            text-align: center;\n            cursor: pointer;\n            padding-bottom: 58px;\n        }\n    }\n\n    &__popup {\n        background: #333333;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        align-items: center;\n        text-align: center;\n        color: #ffffff;\n        border-radius: 8px !important;\n\n        &__span {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 12px;\n            line-height: 18px;\n            align-items: center;\n            text-align: center;\n            color: #ffffff;\n        }\n    }\n\n    &__pie-chart {\n        height: 150px;\n        width: 150px;\n        margin: auto;\n    }\n\n    &__progress-bar {\n        &__line {\n            display: flex;\n            margin-top: 25px;\n            align-items: center;\n        }\n\n        &__text {\n            width: 60px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            align-items: center;\n        }\n\n        &__bar {\n            padding-top: 5px;\n        }\n    }\n\n    &__modal-footer {\n        margin-top: 30px;\n\n        &__legend {\n        }\n\n        &__table {\n            margin: auto;\n        }\n\n        &__td {\n            \n        }\n\n        &__items {\n            display: flex;\n            padding-left: 15px;\n        }\n\n        &__text {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            align-items: center;\n            color: #868686;\n            padding-right: 10px;\n        }\n\n        &__span {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            align-items: center;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
